import { useSnackbar } from "notistack";
import { useState, useEffect, useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { convertQueryStringToObject } from "../../services/libService";
import { allRoutes } from "../config";

export const usePagination = () => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return [page, setPage, rowsPerPage, handleChangeRowsPerPage];
};
export const useParamFilter = (defaultParams, getDataPromise = () => true) => {
  const { search, pathname } = useLocation();
  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();
  const prevSearch = convertQueryStringToObject(search);
  const [loading, setLoading] = useState(false);
  const filter = convertQueryStringToObject(search);
  const [data, setData] = useState(null);
  const [isAllow, setAllow] = useState(true);
  const countRef = useRef(0);
  const fetchData = (filterObject, getDataFunc) => {
    setAllow(true);
    setLoading(true);
    setData(null);
    countRef.current += 1;
    let currentCount = countRef.current;
    let lastFilter = { ...defaultParams, ...filterObject };
    // lọc bỏ những tham số rống
    Object.keys(lastFilter).forEach((key) => {
      // eslint-disable-next-line eqeqeq
      if (lastFilter[key] == null || lastFilter[key] === "" || lastFilter[key] == undefined) delete lastFilter[key];
    });
    let func = getDataFunc ?? getDataPromise;
    func?.(lastFilter).then((res) => {
      if (currentCount !== countRef.current) return;
      if (res.code === 200) {
        setData(res.data);
      } else if (res.code === 403) {
        setAllow(false);
      } else enqueueSnackbar(res.message);
      setLoading(false);
    });
    history.replace(`${pathname}?${new URLSearchParams(lastFilter)}`);
  };
  const onPageChange = (e, page) => {
    page = page + 1;
    fetchData({ ...prevSearch, page });
  };
  const onPerPageChange = (e) => {
    fetchData({ ...prevSearch, per_page: e.target.value, page: 1 });
  };
  return {
    responseData: data,
    fetchData: (cb, getDataFunc) => (typeof cb === "function" ? fetchData(cb?.(prevSearch), getDataFunc) : fetchData(cb, getDataFunc)), // event dùng để lấy dữ liệu
    data: data?.data || [], // dữ liệu bản ghi
    total: data?.total, // tổng số bản ghi
    setData: (cb) => setData((prev) => ({ ...prev, data: typeof cb === "function" ? cb(prev.data) : cb })), // set data thủ công
    page: +filter.page - 1 || 0,
    perPage: +filter.per_page || 50,
    setPage: onPageChange,
    setPerPage: onPerPageChange,
    filter, // query từ location
    isAllow, // có quyền xem dữ liệu hay k
    loading, // api đang load hay không
  };
};
export const useTitle = () => {
  const location = useLocation();
  useEffect(() => {
    document.title = allRoutes[location.pathname] || "Efuel";
  }, [location.pathname]);
};
export const useValueRef = (state) => {
  const ref = useRef();
  useEffect(() => {
    ref.current = state;
  }, [state]);
  return ref;
};
